import * as React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "css/brm-react-tabs.css";
import DynamicSubTabSelector from "components/elements/DynamicSubTabSelector";
import { DetailsTableMap } from "brm/tables/details/DetailsTableMap";
import { DetailTableType } from "features/brm";
import { useRoles } from "features/brm/hooks/useRoles";
import PropTypes from "prop-types";

const accessMenu = [DetailTableType.ATTACK_SURFACES, DetailTableType.ATTACK_VECTORS, DetailTableType.ENTRY_POINTS];

const attacksMenu = [DetailTableType.ATTACKERS];

const systemMenu = [DetailTableType.NODES, DetailTableType.EXCHANGES, DetailTableType.ACTIVITIES];

const AccessPointDetails = ({ selectedElement }) => {
  const elementNameInUrl = DetailTableType.ACCESS_POINTS.key;

  const { isRiskAnalyst } = useRoles();
  const [selectedContext, setSelectedContext] = React.useState(DetailTableType.NODES.key);
  const [selectedAccessContext, setSelectedAccessContext] = React.useState(DetailTableType.ENTRY_POINTS.key);
  const [selectedAttackContext, setSelectedAttackContext] = React.useState(DetailTableType.ATTACKERS.key);
  const [curr, setCurr] = React.useState("");

  return (
    <Tabs id="AccessPointDetails_Tabs">
      <TabList id="AccessPointDetails_Tablist">
        <Tab onClick={() => setCurr(DetailTableType.SYSTEM.name)}>
          <DynamicSubTabSelector
            title={DetailTableType.SYSTEM.name}
            menu={systemMenu}
            setSelectedContext={setSelectedContext}
            curr={curr}
          />
        </Tab>
        <Tab onClick={() => setCurr(DetailTableType.ACCESS.name)}>
          <DynamicSubTabSelector
            title={DetailTableType.ACCESS.name}
            menu={accessMenu}
            setSelectedContext={setSelectedAccessContext}
            curr={curr}
          />
        </Tab>

        {isRiskAnalyst && (
          <>
            <Tab onClick={() => setCurr(DetailTableType.ATTACK.name)}>
              <DynamicSubTabSelector
                title={DetailTableType.ATTACK.name}
                menu={attacksMenu}
                setSelectedContext={setSelectedAttackContext}
                curr={curr}
              />
            </Tab>
          </>
        )}
      </TabList>

      <TabPanel>
        <DetailsTableMap
          elementNameInUrl={elementNameInUrl}
          selectedElement={selectedElement}
          selectedContext={selectedContext}
        />
      </TabPanel>

      <TabPanel>
        <DetailsTableMap
          elementNameInUrl={elementNameInUrl}
          selectedElement={selectedElement}
          selectedContext={selectedAccessContext}
        />
      </TabPanel>

      {isRiskAnalyst && (
        <>
          <TabPanel>
            <DetailsTableMap
              elementNameInUrl={elementNameInUrl}
              selectedElement={selectedElement}
              selectedContext={selectedAttackContext}
            />
          </TabPanel>
        </>
      )}
    </Tabs>
  );
};

AccessPointDetails.propTypes = {
  selectedElement: PropTypes.object.isRequired,
};

export default AccessPointDetails;
